<template>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" />
  <div class="login-main">
    <div class="bg-grid"></div>
    <div class="bg-glow"></div>
    <div class="login-right">
      <div class="card-login">
        <h1>Redefinir Senha</h1>
        <form autocomplete="off" @submit.prevent="submitReset">
          <div class="textfield">
            <i class="fas fa-envelope leading-icon"></i>
            <input
              type="email"
              v-model.trim="email"
              placeholder="Email"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="none"
              spellcheck="false"
              inputmode="email"
            />
          </div>

          <div class="textfield">
            <i class="fas fa-lock leading-icon"></i>
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              placeholder="Nova senha"
              autocomplete="off"
            />
            <button
              type="button"
              class="toggle-eye"
              @click="showPassword = !showPassword"
              :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
            >
              <i :class="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
            </button>
          </div>

          <div class="textfield">
            <i class="fas fa-lock leading-icon"></i>
            <input
              :type="showConfirmPassword ? 'text' : 'password'"
              v-model="confirmPassword"
              placeholder="Confirmar senha"
              autocomplete="off"
            />
            <button
              type="button"
              class="toggle-eye"
              @click="showConfirmPassword = !showConfirmPassword"
              :aria-label="showConfirmPassword ? 'Ocultar confirmação' : 'Mostrar confirmação'"
            >
              <i :class="showConfirmPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
            </button>
          </div>

          <button type="submit" class="button-login" :disabled="isSubmitting">
            {{ isSubmitting ? 'Salvando...' : 'Salvar nova senha' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_BASE_URL } from '@/config/env';
import { toastError, toastSuccess } from '@/utils/toast';

export default {
  name: 'MudaSenha',
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      isSubmitting: false,
    };
  },
  methods: {
    async submitReset() {
      if (!this.email || !this.password || !this.confirmPassword) {
        toastError('Preencha todos os campos.');
        return;
      }
      if (this.password.length < 8) {
        toastError('A senha deve ter pelo menos 8 caracteres.');
        return;
      }
      if (this.password !== this.confirmPassword) {
        toastError('As senhas não coincidem.');
        return;
      }

      this.isSubmitting = true;
      try {
        await axios.post(`${API_BASE_URL}/api/v1/auth/reset-password`, {
          email: this.email,
          new_password: this.password,
        });
        toastSuccess('Senha alterada com sucesso!');
        this.$router.push({ name: 'Login' });
      } catch (error) {
        const message = error?.response?.data?.error || 'Não foi possivel redefinir a senha.';
        toastError(message);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans', sans-serif;
}

body * {
  box-sizing: border-box;
}

.login-main {
  width: 100%;
  min-height: 100dvh;
  --bg: #11131a;
  --accent-a: rgba(78, 115, 223, 0.12);
  --accent-b: rgba(155, 89, 182, 0.14);
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, var(--accent-a), transparent 45%),
    radial-gradient(circle at top right, var(--accent-b), transparent 40%),
    var(--bg);
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-grid,
.bg-glow {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.bg-grid {
  background:
    linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: 32px 32px;
  opacity: 0.4;
}

.bg-glow {
  background: transparent;
}

.login-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;
}

.card-login {
  width: min(400px, 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px 35px;
  border-radius: 15px;
  border: 1px solid transparent;
  background:
    linear-gradient(160deg, rgba(18, 26, 44, 0.72), rgba(13, 19, 34, 0.78)) padding-box,
    linear-gradient(120deg, #4e73df, #9b59b6) border-box;
  backdrop-filter: blur(18px) saturate(120%);
  -webkit-backdrop-filter: blur(18px) saturate(120%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 0 0 1px rgba(78, 115, 223, 0.24),
    0 14px 30px rgba(4, 10, 24, 0.5),
    0 0 26px rgba(155, 89, 182, 0.2);
}

.card-login h1 {
  color: #ffffff;
  font-weight: 600;
  margin: 0 0 20px;
}

.card-login form {
  width: 100%;
}

.textfield {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.textfield input {
  flex: 1;
  border: none;
  border-radius: 10px;
  padding: 15px 50px 15px 50px;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 12pt;
  outline: none;
  transition: background-color 0.3s ease;
}

.textfield input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.leading-icon {
  position: absolute;
  left: 15px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  transition: visibility 0.3s ease, opacity 0.3s ease;
}

.textfield input:focus ~ .leading-icon {
  visibility: hidden;
  opacity: 0;
}

.toggle-eye {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.75);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.toggle-eye:hover {
  color: #ffffff;
}

.toggle-eye i {
  position: static;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.2) inset !important;
  background-color: rgba(255, 255, 255, 0.2) !important;
  -webkit-text-fill-color: #ffffff !important;
  transition: background-color 5000s ease-in-out 0s;
}

.button-login {
  width: 100%;
  padding: 12px 0;
  border-radius: 50px;
  text-transform: uppercase;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
  cursor: pointer;
  border: none;
  transition: background 0.3s ease, transform 0.3s ease;
}

.button-login:hover {
  background: linear-gradient(135deg, #5f27cd 0%, #3498db 100%);
  transform: translateY(-3px);
}

@media only screen and (max-width: 1199px) {
  .card-login {
    width: 85%;
  }
}

@media only screen and (max-width: 767px) {
  .login-main {
    flex-direction: column;
  }

  .login-right {
    width: 100%;
    height: auto;
  }

  .card-login {
    width: 90%;
    padding: 26px 20px;
  }
}
</style>
